import React, { useState } from 'react';
import RegionAssignmentTableRow from './RegionAssignmentTableRow';
import { Box, CircularProgress, Paper, Table, TableBody, TableContainer, Typography } from '@mui/material';

const RegionAssignmentTable = ({ data, loading, refetch }) => {
  // Track expanded rows by employeeId
  const [expandedRows, setExpandedRows] = useState({});

  const handleToggleExpand = (employeeId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [employeeId]: !prev[employeeId],
    }));
  };

  if (loading) {
    return (
      // <div>Loading region assignments...</div>
       <Box display="flex" alignItems="center" justifyContent="center" minHeight={120}>
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading region assignments...</Typography>
      </Box>
    );
  }

  if (!data || data.length === 0) {
    return (
      // <div>No region assignments found.</div>
            <Box display="flex" alignItems="center" justifyContent="center" minHeight={120}>
        <Typography>No region assignments found.</Typography>
      </Box>

    );
  }

  return (
    // <div>
    //   <h2>Employee Region Assignments</h2>
    //   {data.map((employee) => (
    //     <RegionAssignmentTableRow
    //       key={employee.EmployeeId}
    //       employee={employee}
    //       assignments={employee.assignments||[]}
    //       expanded={!!expandedRows[employee.EmployeeId]}
    //       onToggleExpand={() => handleToggleExpand(employee.EmployeeId)}
    //       refetch={refetch}
    //     />
    //   ))}
    // </div>
    <Box>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Employee Region Assignments
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableBody>
            {data.map((employee) => (
              <RegionAssignmentTableRow
                key={employee.EmployeeId}
                employeeId={employee.EmployeeId}
                assignments={employee.assignments || []}
                isExpanded={!!expandedRows[employee.EmployeeId]}
                onToggleExpand={() => handleToggleExpand(employee.EmployeeId)}
                refetch={refetch}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RegionAssignmentTable;
